export enum UIErrorTypes {
  Snack = 'Snack',
  Modal = 'Modal',
}

export type UIError = {
  type: UIErrorTypes;
  message: string;
};
